import React from 'react';
import PropTypes from 'prop-types';

import TitleBar from 'components/title_bar';

export default function Header({ modelName, templateName, saving, saveDisabled, onCancel, onSave }) {
  return (
    <TitleBar subtitle={templateName} title={`Edit ${modelName}`}>
      <button className="btn btn-primary me-2" disabled={saving || saveDisabled} type="button" onClick={onSave}>
        Save
      </button>
      <button className="btn btn-ghost" disabled={saving} type="button" onClick={onCancel}>Cancel</button>
    </TitleBar>
  );
}

Header.propTypes = {
  modelName: PropTypes.string.isRequired,
  saveDisabled: PropTypes.bool,
  saving: PropTypes.bool,
  templateName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
